// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmBG_MOaj3zHuwp2ttEI[data-has-many='true'] {
  gap: var(--campaign-info-has-many-gap);
  margin-bottom: var(--campaign-info-has-many-margin-bottom);
  height: var(--campaign-info-has-many-height);
}
.JkBeTCAQzida2kU4f2Du[data-has-many='true'] {
  flex-direction: row;
  width: max-content;
}
/* .campaignInfoDisplayElementsWrapper[data-finished='true'] {
  width: 100%
} */
.JkBeTCAQzida2kU4f2Du[data-has-many="true"][data-view="single"][data-collapsed='true'] {
  flex-direction: column;
  width: var(--campaign-info-timer-max-width-desktop);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .EmBG_MOaj3zHuwp2ttEI[data-has-many='true'] {
    gap: var(--campaign-info-has-many-gap-mobile);
    height: var(--campaign-info-has-many-height-mobile);
  }
  .EmBG_MOaj3zHuwp2ttEI[data-has-many='true'][data-view='multi'] {
    margin-bottom: var(--campaign-info-has-many-margin-bottom-mobile-multi);
  }
  .JkBeTCAQzida2kU4f2Du[data-has-many="true"][data-view="single"][data-collapsed='true'] {
    width: var(--campaign-info-timer-max-width-mobile);
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .EmBG_MOaj3zHuwp2ttEI[data-has-many='true'][data-view='multi'][data-variant='card'][data-finished='true'] {
    margin-bottom: var(--campaign-info-has-many-margin-bottom-mobile-portrait-finished);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .EmBG_MOaj3zHuwp2ttEI[data-has-many='true'][data-view='multi'][data-variant='card'][data-finished='true'] {
    margin-bottom: var(--campaign-info-has-many-margin-bottom-mobile-portrait-finished);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/BottomCardInfo/css/hasManyStyles.module.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,0DAA0D;EAC1D,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;GAEG;AACH;EACE,sBAAsB;EACtB,mDAAmD;AACrD;AACA;EACE;IACE,6CAA6C;IAC7C,mDAAmD;EACrD;EACA;IACE,uEAAuE;EACzE;EACA;IACE,kDAAkD;EACpD;AACF;AACA;AAAA;EACE;IACE,mFAAmF;EACrF;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,mFAAmF;EACrF;AACF;AAAA;AAAA;AAAA","sourcesContent":[".campaignInfoDisplayContainer[data-has-many='true'] {\n  gap: var(--campaign-info-has-many-gap);\n  margin-bottom: var(--campaign-info-has-many-margin-bottom);\n  height: var(--campaign-info-has-many-height);\n}\n.campaignInfoDisplayElementsWrapper[data-has-many='true'] {\n  flex-direction: row;\n  width: max-content;\n}\n/* .campaignInfoDisplayElementsWrapper[data-finished='true'] {\n  width: 100%\n} */\n.campaignInfoDisplayElementsWrapper[data-has-many=\"true\"][data-view=\"single\"][data-collapsed='true'] {\n  flex-direction: column;\n  width: var(--campaign-info-timer-max-width-desktop);\n}\n@media (--campaign-mobile) {\n  .campaignInfoDisplayContainer[data-has-many='true'] {\n    gap: var(--campaign-info-has-many-gap-mobile);\n    height: var(--campaign-info-has-many-height-mobile);\n  }\n  .campaignInfoDisplayContainer[data-has-many='true'][data-view='multi'] {\n    margin-bottom: var(--campaign-info-has-many-margin-bottom-mobile-multi);\n  }\n  .campaignInfoDisplayElementsWrapper[data-has-many=\"true\"][data-view=\"single\"][data-collapsed='true'] {\n    width: var(--campaign-info-timer-max-width-mobile);\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .campaignInfoDisplayContainer[data-has-many='true'][data-view='multi'][data-variant='card'][data-finished='true'] {\n    margin-bottom: var(--campaign-info-has-many-margin-bottom-mobile-portrait-finished);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignInfoDisplayContainer": `EmBG_MOaj3zHuwp2ttEI`,
	"campaignInfoDisplayElementsWrapper": `JkBeTCAQzida2kU4f2Du`
};
export default ___CSS_LOADER_EXPORT___;
